import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetFaq = createAsyncThunk<AxiosResponse<any, any>, any>(
  "faq/toGetFaq",
  async (lang) => {
    try {
      const response = await axios.get(`${baseUrlApi}portal/faq?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
